import type { Media, MediaCategory } from './media';
import { defaultPatientData, type PatientData } from './patientData';
import type { StateData } from './stateData';

export const CompletionStatusColor = {
  COMPLETED: '#D20302',
  ACTIVE: '#76cb01',
  WAITING: '#FFC802',
} as const;

export type CaseData = {
  mockup?: boolean;
  completed?: boolean;
  score?: number;
  data?: CaseData;
  id?: string;
  name: string;
  category?: string;
  roomNumber?: string;
  description: string;
  patientFileId: string;
  initialStateId?: number;
  status?: string;
  patientFile: PatientData;
  states?: StateData[];
  organizationId?: string;
  patientPaneHistory?: string;
  orderHistory?: string;
  introTitle?: string;

  gender?: string;
  age?: number;
  complaint?: string;
  vitalSigns?: {
    [key: string]: string;
    HR: string;
    BP: string;
    SpO2: string;
    RR: string;
    Temperature: string;
    Height: string;
    Weight: string;
    'Pain Score': string;
    'O2 Source': string;
    PainScore: string;
  };
  hpi?: string;
  medications?: string;
  pmh?: string;
  physicalExam?: {
    [key: string]: string;
    General: string;
    HEENT: string;
    Neck: string;
    Cardiac: string;
    Pulmonary: string;
    Abdomen: string;
    Extremities: string;
    Neurologic: string;
    Genitourinary: string;
    Skin: string;
    Back: string;
    Psychiatric: string;
  };
  allergies?: string;
  initialRespiratoryOrders?: string;
  rating?: number;
  providerName?: string;
  providerNameLast?: string;
  room?: string;
  completionStatus?: string;
  gray?: boolean;
  currentState?: StateData;
  previousState?: StateData;
  caseStudyId?: string;
  finished?: boolean;
  history?: HistoryData[];
  priorVisit?: string;
  vimeoLink?: string;
  patientName?: string;
  patientNameLast?: string;
  profileImageUrl?: string;
  profileImageUrlSigned?: string;
  isTemplate: boolean;
  priorNotes?: MediaCategory | null;
  casePopUp?: Media | null;
  popupText?: string;
  popupFrom?: string;
};

export const defaultCaseData: CaseData = {
  mockup: false,
  completed: false,
  score: 0,
  id: '',
  name: '',
  patientFileId: '',
  description: '',
  status: '',
  patientFile: defaultPatientData,
  organizationId: '',
  isTemplate: false,
  gender: '',
  age: 0,
  complaint: '',
  vitalSigns: {
    HR: '',
    BP: '',
    SpO2: '',
    RR: '',
    Temperature: '',
    'Pain Score': '',
    Height: '',
    Weight: '',
    'O2 Source': '',
    PainScore: '',
  },
  hpi: '',
  medications: '',
  pmh: '',
  physicalExam: {
    General: '',
    HEENT: '',
    Neck: '',
    Cardiac: '',
    Pulmonary: '',
    Abdomen: '',
    Extremities: '',
    Neurologic: '',
    Genitourinary: '',
    Skin: '',
    Back: '',
    Psychiatric: '',
  },
  allergies: '',
  initialRespiratoryOrders: '',
  patientName: '',
  profileImageUrl: '',
  profileImageUrlSigned: '',
  rating: 0,
  vimeoLink: '',
  priorVisit: '',
  orderHistory: '',
  priorNotes: null,
  introTitle: '',
  popupText: '',
  popupFrom: '',
};

export type StartedCaseData = {
  id: string;
  userId: string;
  caseStudyId: string;
  previousStateId: number;
  currentStateId: number;
  finished: boolean;
  score: number;
  previousState: StateData;
  currentState: StateData;
  history: HistoryData[];
  mockup?: boolean;
};

export type HistoryData = {
  transitionedFrom: number;
  transitionedTo: number;
  evaluatedConditions: Conditions[];
};

export type Conditions = {
  type: string;
  field: string;
  operator: string;
  value: number;
  units: string | null;
  route: string | null;
  note: string | null;
};
